import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { SharedSVG } from '@common_components/svg/shared.svg';

const SharedIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <SharedSVG/>
    </div>
  );
};

export { SharedIcon };
